import React, { useState } from "react";
import { useParams } from "react-router";
import ToggleDropdown from '../reused-components/SidebarTabs';
import AddProducts from '../reused-components/AddProducts';
import Profile from '../reused-components/Profile';
import UserTable from '../tables/UsersTable';
import smlogo from '../../img/sm-logo.svg';
import profileImage from '../../img/user-profile.png';
import SearchFilter from "../reused-components/SearchFilter";
import DarkModeSwitch from "../reused-components/ToggleDarkMode";
import DownloadDropdown from "../reused-components/DownloadDropdown";
import { fetchUsers } from "../../services/apiService";
import { useTelemetryContext } from "../../contexts/TelemetryContext";

const USERS_CSV_COLUMNS = [
    { key: "id", label: "ID" },
    { key: "email", label: "Email" },
    { key: "nick_name", label: "Name" },
    { key: "marketing_record", label: "Marketing" },
    { key: "created_at", label: "Member Since" },
];

export default function Login() {
    document.title = "Users | Telemetry";

    const { productId } = useParams();
    const { selectedProduct } = useTelemetryContext();
    const [perPage, setPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [tableData, setTableData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);

    const handlePerPageClick = (perPage) => {
        setPerPage(perPage);
    }

    const handleSearch = (searchTerm) => {
        console.log('Search term from Users component:', searchTerm); // Debugging
        setSearchTerm(searchTerm);
    };

    return (
        <div className="telemetry-page-wrapper">
            <header className="telemetry-header">
                <div className="telemetry-logo-section">
                    <a href="#"><img src={smlogo} alt="Telemetry" /></a>
                </div>
                <div className="telemetry-top">
                    <h1>Users</h1>
                    <div className="telemetry-top-right">
					<DarkModeSwitch />
                        <SearchFilter onSearch={handleSearch} />
                        <AddProducts />
                        <Profile image={profileImage} />
                    </div>
                </div>
            </header>
            <main className="telemetry-main">
                <aside className="telemetry-sidebar">
                    <ToggleDropdown tabactive={1} tabactive2={1} />
                </aside>
                <section className="telemetry-content">
                    <div className="telemetry-filter">
                        <div className="telemetry-filter-right">
                        <DownloadDropdown
                            allLabel="All users"
                            tableLabel="Table users"
                            tableData={tableData}
                            columns={USERS_CSV_COLUMNS}
                            filenameBase="users"
                            onDownloadAll={async () => {
                                if (!selectedProduct?.id || !productId) return [];
                                const perPageAll = Math.max(totalRows || 1, 5000);
                                const res = await fetchUsers(selectedProduct.id, 1, perPageAll, searchTerm);
                                return res.data || [];
                            }}
                        />
                        </div>
                    </div>
                    <div className="telemetry-data-table-wrapper">
                        <div className="telemetry-data-table-container">
                            <UserTable
                                paginationPerPage={perPage}
                                searchTerm={searchTerm}
                                onDataLoad={({ data, total }) => {
                                    setTableData(data);
                                    setTotalRows(total);
                                }}
                            />
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}
